import PriceListIcon from "@mui/icons-material/RequestQuote";
import { useSnackbar } from "notistack";
import type { FC } from "react";
import { getCalculationPriceList } from "../../../api/api";
import DownloadPdfButtonWithYear from "../../components/downloadFileButton/DownloadPdfButtonWithYear";

interface Props {
  readonly calculationId: string;
  readonly version: number;
  readonly calculationName: string;
}

const DownloadPriceListButton: FC<Props> = ({ calculationId, version, calculationName }) => {
  const { enqueueSnackbar } = useSnackbar();
  const options = [
    { name: "Pobierz cennik", apiDefinition: (year: number) => getCalculationPriceList(calculationId, year, version) },
  ];
  return (
    <DownloadPdfButtonWithYear
      buttonText="Pobierz cennik"
      useDynamicPrices={false}
      startIcon={<PriceListIcon />}
      options={options}
      filename={(year) => `${calculationName} - cennik ${year}.pdf`}
      onError={() => enqueueSnackbar("Nie udało się pobrać pliku PDF z cennikiem", { variant: "error" })}
    />
  );
};

export default DownloadPriceListButton;
